const ConversationStructure = {
    conversations: [
      {
        month: "", // e.g., "June 2025"
        allmessages: [
          {
            date: "", // e.g., "2025-06-05"
            messages: [
              {
                id: "", // e.g., "msg1"
                sender: "", // e.g., "Alex"
                content: "", // e.g., "Hey, how are you?"
                timestamp: "" // ISO format e.g., "2025-06-05T09:00:00Z"
              }
            ]
          }
        ]
      }
    ]
  };
  
  export default ConversationStructure;
  